<p class="m-0">
  {{numberOfAllSelectedLayers$ | async}}/{{MAX_SELECTED_MAP_LAYERS}} Selected
</p>
